import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from "react-router-dom";
export default function Children() {
    // 嵌套路由中间 内容 我们这个组件 啥也不干 你也可以加一些布局内容
    return /*#__PURE__*/ _jsx(Outlet, {});
}
